const arrowIcon = require('@app/images/arrow_circle.svg');

import * as React from 'react';
import {Link} from 'react-router-dom';

import {List} from '@common/typescript/objects/List';

import {rest} from '@app/components/Api';
import AreaHeader from '@app/components/UI/Area-blocks/AreaHeader/AreaHeader';
import BannerInner from '@app/components/UI/BannerInner/BannerInner';
import MiddleText from '@app/components/UI/MiddleText/MiddleText';
import NewsPreview from '@app/components/UI/NewsPreview/NewsPreview';
import SliderDotsArrows from '@app/components/UI/Slider/SliderDotsArrows';
import {Testimonials} from '@app/objects/Testimonials';
import {LinkItem} from '@app/objects/LinkItem';
import LinkMore from '@app/components/LocalCommon/LinkMore/LinkMore';

const AreaAbout = (props) => {
	const {area} = props;
	const [testimonials, setTestimonials] = React.useState<Testimonials[]>([]);
	const [news, setNews] = React.useState<LinkItem[]>([]);

	React.useEffect(() => {
		rest.get<List<Testimonials>>(`v1/areas/${area.id}/testimonials?count=3`)
			.then(res => setTestimonials(res.list));

		rest.get<List<LinkItem>>(`v1/areas/${area.id}/news`)
			.then(res => setNews(res.list));
	}, []);

	return (
		<>
			<div className="area">
				<AreaHeader area={area}/>

				{ area.vacationDates && area.unavailabilityMessage &&
					<BannerInner message={area.unavailabilityMessage}/>
				}

				<MiddleText title={'About'} text={area.availabilityDescription}/>

				<MiddleText title={'Service area'} text={area.serviceAreaDescription}/>

				{
					testimonials.length ?
						<>
							<MiddleText title={'Testimonials'}>
								<SliderDotsArrows sliderItems={testimonials} sliderItemsType="cardTes"/>
							</MiddleText>
							<Link to="/veterinarian-testimonials" className="btn btn-md btn-primary btn-more">See all testimonials</Link>
						</>
					: null
				}

				{news && news.length > 0 && <MiddleText title={'In the news'}>
					<section className="area__news">
						{news.map((item, index) => <NewsPreview
							key={index}
							url={item.url}
							title={item.title}
							source={item.description}
						/>)}
					</section>
					<LinkMore linkMoreLink={'/in-the-news'} linkMoreCaption="See more news clippings" />
				</MiddleText>}
			</div>
		</>
	);
};

export default AreaAbout;